import axios from "axios";
import {API_USER_URL} from "src/config";

const instance = axios.create({
  baseURL: `${API_USER_URL}`,
  headers: {
    "Access-Control-Allow-Origin": "http://localhost:3000",
    "Access-Control-Allow-Headers": "Origin, X-Requested-With, Content-Type, Accept"
  }
});

export default instance;
